'use strict';

jQuery(function ($) {
	// Au scroll faire apparaitre ou disparaitre le bouton de retour en haut de page
	$(window).on('scroll', function () {
		var $back = $('.back-to-top');
		var duration = 600;
		var posScroll = $(document).scrollTop();

		if (posScroll >= 550) {
			$back.fadeIn(duration);
		} else {
			$back.fadeOut(duration);
		}
	});

	$('.back-to-top').on('click', function (event) {
		event.preventDefault();
		$('html, body').animate({ scrollTop: 0 }, 500);
	});

	function readingTime(card) {
		const wordsPerMinute = 200;
		const the_text = $(card).find('.text').text();
		const noOfWords = the_text.split(/\s/g).length;
		const minutes = noOfWords / wordsPerMinute;
		const readTime = Math.ceil(minutes);

		let minuteWord;

		if (readTime <= 1){
			minuteWord = "minute";
		} else {
			minuteWord = "minutes";
		}
		$(card).find('.reading-time').text(`${readTime} ${minuteWord} à lire`);

	}

	$('.b-actualites__inner__block .card-body').each(function( index, card ) {
		readingTime(card);
	});
});
